/** Get current element padding for each side */
export function getElementPadding(element: HTMLElement): {
  top: number
  right: number
  bottom: number
  left: number
} {
  const style = window.getComputedStyle(element)
  return {
    top: parseFloat(style.paddingTop),
    right: parseFloat(style.paddingRight),
    bottom: parseFloat(style.paddingBottom),
    left: parseFloat(style.paddingLeft),
  }
}

/** Gets the inner width of an element (excluding padding). Weirdly there's no built-in method for this. */
export function getElementContentWidth(element: HTMLElement): number {
  const padding = getElementPadding(element)
  return element.clientWidth - padding.left - padding.right
}
